import produce, {Draft} from 'immer';
import {handleActions} from 'redux-actions';
import {ActionType} from 'redux-promise-middleware';
import {Reducer} from 'redux';

import utils from '@utils';
import actions from '../actions';
import initialState from '../store/initialState';

const reducer: Reducer<NotificationsStore, any> = handleActions(
  // ページング用
  {
    [`${actions.notifications.updateCurrentNotifications}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,

        (draftState: Draft<NotificationsStore>) => {
          draftState.pagination.data = action.payload.data;
          draftState.pagination.totalCount = action.payload.totalCount;
          draftState.pagination.totalPages = action.payload.totalPages;
          draftState.pagination.current = action.payload.current;
          draftState.pagination.sort = action.payload.sort;
        }
      );
      return newState;
    },
    // ページング用 (災害通知履歴詳細)
    [`${actions.notifications.updateCurrentNotificationDetail}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.pagination.data = action.payload.data;
          draftState.detail.pagination.totalCount = action.payload.totalCount;
          draftState.detail.pagination.totalPages = action.payload.totalPages;
          draftState.detail.pagination.current = action.payload.current;
          draftState.detail.pagination.sort = action.payload.sort;
        }
      );

      return newState;
    },
    // 検索キーワード
    [`${actions.notifications.updateSearchWordsNotifications}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.search = action.payload.keywords;
          draftState.search.toSentDatetime = utils.date.format(
            action.payload.keywords.toSentDatetime,
            'YYYY-MM-DD',
            true
          );
          draftState.search.fromSentDatetime = utils.date.format(
            action.payload.keywords.fromSentDatetime,
            'YYYY-MM-DD'
          );
          draftState.pagination.data = action.payload.pagination.data;
          draftState.pagination.totalCount =
            action.payload.pagination.totalCount;
          draftState.pagination.totalPages =
            action.payload.pagination.totalPages;
          draftState.pagination.current = action.payload.pagination.current;
          draftState.pagination.sort = action.payload.pagination.sort;
        }
      );
      return newState;
    },

    [`${actions.notifications.clearSearchWords}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.search = action.payload;
        }
      );
      return newState;
    },

    [`${actions.users.clearTableSort}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<UsersStore>) => {
        draftState.pagination.sort = action.payload.sort;
      });

      return newState;
    },

    [`${actions.notifications.clearDetailSort}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.pagination.sort = action.payload.sort;
        }
      );

      return newState;
    },

    [`${actions.notifications.getOneNotification}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail = action.payload.detail.data;
          draftState.detail.pagination = action.payload.pagination;
        }
      );

      return newState;
    },
    [`${actions.notifications.getSummarizedNotification}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail = action.payload.detail.data;
          draftState.detail.pagination = action.payload.pagination;
        }
      );

      return newState;
    },

    [`${actions.notifications.getNotificationDetail}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.sentDatetime = action.payload.detail.sentDatetime;
          draftState.detail.disasterType = action.payload.detail.disasterType;
          draftState.detail.intensity = action.payload.detail.intensity;
          draftState.detail.replyCount = action.payload.detail.replyCount;
          draftState.detail.sentSuccessCount =
            action.payload.detail.sentSuccessCount;
          draftState.detail.sentExecutionCount =
            action.payload.detail.sentExecutionCount;
          draftState.detail.prefecture = action.payload.detail.prefecture;
          draftState.detail.isManual = action.payload.detail.isManual;
          draftState.detail.message = action.payload.detail.message;
          draftState.detail.noReplyCount = action.payload.detail.noReplyCount;
          draftState.detail.sentServerErrorCount =
            action.payload.detail.sentServerErrorCount;
        }
      );

      return newState;
    },
    [`${actions.notifications.updateDetailSearchWords}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.search = action.payload;
        }
      );
      return newState;
    },
    [`${actions.notifications.clearDetailSearch}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.search = action.payload;
        }
      );
      return newState;
    },
    [`${actions.notifications.getDetailAnswer}_${ActionType.Fulfilled}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.answer = action.payload;
        }
      );
      return newState;
    },
    [`${actions.notifications.getDetailAnswer}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.answer = action.payload;
        }
      );
      return newState;
    },
    [`${actions.notifications.updateActiveNotifications}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.pagination.data.active = action.payload.active;
          draftState.pagination.current = action.payload.nextCurrent;
        }
      );
      return newState;
    },
    [`${actions.notifications.updateActiveNotificationDetails}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.pagination.data.active = action.payload.active;
          draftState.detail.pagination.current = action.payload.nextCurrent;
        }
      );
      return newState;
    },

    [`${actions.notifications.updateSearchTime}`](
      state: NotificationsStore,
      action: any
    ) {
      const newState = produce(
        state,
        (draftState: Draft<NotificationsStore>) => {
          draftState.detail.recentSearchDatetime =
            action.payload.recentSearchDatetime;
        }
      );
      return newState;
    },
  },
  initialState.notifications
);

export default reducer;
